import ListProviders from "@/views/agro_exporter/certifications/providers/ListProviders.vue";
import ShowOrganization from "@/views/agro_exporter/certifications/providers/ShowOrganization.vue";
import NewOrganizationCertification from "@/views/agro_exporter/certifications/providers/NewOrganizationCertification.vue";
import EditOrganizationCertification from "@/views/agro_exporter/certifications/providers/EditOrganizationCertification.vue";
import ShowPackingHouse from "@/views/agro_exporter/certifications/providers/ShowPackingHouse.vue";
import ShowProducer from "@/views/agro_exporter/certifications/providers/ShowProducer.vue";
import NewPackingHouseCertification from "@/views/agro_exporter/certifications/providers/NewPackingHouseCertification.vue";
import EditPackingHouseCertification from "@/views/agro_exporter/certifications/providers/EditPackingHouseCertification.vue";
import NewCropFieldCertification from "@/views/agro_exporter/certifications/providers/NewCropFieldCertification.vue"
import EditCropFieldCertification from "@/views/agro_exporter/certifications/providers/EditCropFieldCertification.vue";
import ManageProvider from "@/views/agro_exporter/certifications/providers/ManageProvider.vue";
import NewCertificationReview from "@/views/agro_exporter/certifications/providers/NewCertificationReview.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "certifications",
  permission: "providers"
});

export default [
  {
    path: "/ae/:agro_exporter_id/certifications/providers/list_providers",
    name: routeName(""),
    redirect: { name: routeName("list_providers") }
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/list_providers",
    name: routeName("list_providers"),
    component: ListProviders,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/show_organization/:organization_id",
    name: routeName("show_organization"),
    component: ShowOrganization,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/new_organization_certification/:organization_id",
    name: routeName("new_organization_certification"),
    component: NewOrganizationCertification,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/edit_organization_certification/:organization_id/:organization_certification_id",
    name: routeName("edit_organization_certification"),
    component: EditOrganizationCertification,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/show_packing_house/:packing_house_id",
    name: routeName("show_packing_house"),
    component: ShowPackingHouse,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/new_packing_house_certification/:packing_house_id",
    name: routeName("new_packing_house_certification"),
    component: NewPackingHouseCertification,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/edit_packing_house_certification/:packing_house_id/:packing_house_certification_id",
    name: routeName("edit_packing_house_certification"),
    component: EditPackingHouseCertification,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/show_producer/:producer_id",
    name: routeName("show_producer"),
    component: ShowProducer,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/new_crop_field_certification/:producer_id",
    name: routeName("new_crop_field_certification"),
    component: NewCropFieldCertification,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/edit_crop_field_certification/:producer_id/:crop_field_certification_id",
    name: routeName("edit_crop_field_certification"),
    component: EditCropFieldCertification,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/manage/:provider_type/:provider_id",
    name: routeName("manage_provider"),
    component: ManageProvider,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/certifications/providers/new_certification_review/:provider_type/:provider_id",
    name: routeName("new_certification_review"),
    component: NewCertificationReview,
    props: true,
    meta: META
  }
];
